var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mc-trackvideo-card--timeout"},[_c('i',{staticClass:"mc-fa icon-outline_video-off"}),_c('p',[_vm._v(_vm._s(_vm.$t('trackVideo.timeout')))]),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){return _vm.$emit('clickContinue')}}},[_vm._v(_vm._s(_vm.$t('trackVideo.continueStreaming')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }